export enum eCDSections {
  /** Section A */
  origination = 'origination',
  /** Section B */
  services_not_shopped_for = 'services_not_shopped_for',
  /** Section C */
  services_shopped_for = 'services_shopped_for',
  /** Section E */
  recording_fees_and_taxes = 'recording_fees_and_taxes',
  /** Section F */
  prepayments = 'prepayments',
  /** Section G */
  escrow_at_closing = 'escrow_at_closing',
  /** Section H */
  other_costs = 'other_costs',
  /** Payoffs (Not a lettered section) */
  payoffs = 'payoffs',
  adjustments = 'adjustments',
  lender_credits = 'lender_credits',
  due_from_buyer = 'due_from_buyer',
  paid_already_by_buyer = 'paid_already_by_buyer',
  due_to_seller = 'due_to_seller',
  due_from_seller = 'due_from_seller',
}
